export const transform = (map) => {
  return {
    labels: map.ChartData.map(k => k[0]),
    series: [map.ChartData.map(k => k[1])]
  }
}



// WEBPACK FOOTER //
// ./src/core/charts/transform.js